{
  "name": "12-JI (3,7,11)",
  "description": "12-tone Undecimal-Septimal-Tertial Rational Intonation scale, derived from harmonic partial row intervals limited to the prime subgroup combining 2, 3, 7, and 11. The usual JI intervals based on 5 are not included, and the typical consonant chord is 6:7:8:9:11:12.",
  "scale": [
    "33/32",
    "9/8",
    "7/6",
    "21/16",
    "4/3",
    "11/8",
    "3/2",
    "77/48",
    "27/16",
    "7/4",
    "11/6",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-JI-3.7.11",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": ["C", "C", "D", "E", "F", "F", "F", "G", "A", "A", "B", "B"],
  "note_colors": [
    "#ffa3a3",
    "#dfffd6",
    "#ffffff",
    "#ffe5e5",
    "#ffe5e5",
    "#ffffff",
    "#dfffd6",
    "#ffffff",
    "#e9ecc1",
    "#ffffff",
    "#ffe5e5",
    "#dfffd6"
  ],
  "equivSteps": 12,
  "fundamental": 440,
  "reference_degree": 9,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
